import { useState } from "react";
import { Download } from "lucide-react";
import { useInstallCapability } from "@/hooks/useInstallCapability";
import { DASHBOARD } from "@/constants/testIds";

const DISMISS_KEY = "mastro.pwa.installSuggestionDismissed.v1";

export const InstallSuggestion = () => {
  const { standalone, ios, canInstall, installed, promptInstall } = useInstallCapability();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "true";
    } catch {
      return false;
    }
  });

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, "true");
    } catch {
      /* localStorage non disponibile: nascondiamo comunque per la sessione */
    }
    setDismissed(true);
  };

  // Standalone/installed ha sempre precedenza sul localStorage.
  if (installed || standalone) return null;
  if (dismissed) return null;
  // Mostra solo se installabile (Chromium) oppure iOS Safari.
  if (!canInstall && !ios) return null;

  const onInstall = async () => {
    const choice = await promptInstall();
    // Rifiutato/dismissed → proposta post-login rimandata (resta in Impostazioni).
    if (!choice || choice.outcome !== "accepted") dismiss();
  };

  return (
    <div
      data-testid={DASHBOARD.installSuggestion}
      className="mb-8 rounded-2xl border border-neutral-800 bg-neutral-950 px-5 py-4"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="text-base font-bold text-white md:text-lg">
            Mastro sempre a portata di mano
          </h2>
          <p className="mt-1 text-sm text-neutral-300">
            Aggiungilo alla schermata Home e aprilo come un'app quando vuoi controllare i tuoi lavori.
          </p>

          {canInstall ? (
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <button
                data-testid={DASHBOARD.installSuggestionInstall}
                onClick={onInstall}
                className="inline-flex items-center gap-1.5 rounded-lg bg-teal-600 px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-teal-700"
              >
                <Download className="h-4 w-4" /> Installa Mastro
              </button>
              <button
                data-testid={DASHBOARD.installSuggestionDismiss}
                onClick={dismiss}
                className="inline-flex items-center rounded-lg px-3 py-2 text-sm font-medium text-neutral-300 transition-colors hover:text-white"
              >
                Non ora
              </button>
            </div>
          ) : (
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <p data-testid={DASHBOARD.installSuggestionIosHint} className="text-sm text-neutral-300">
                Su iPhone: apri Condividi e scegli "Aggiungi alla schermata Home".
              </p>
              <button
                data-testid={DASHBOARD.installSuggestionDismiss}
                onClick={dismiss}
                className="inline-flex items-center rounded-lg px-3 py-2 text-sm font-medium text-neutral-300 transition-colors hover:text-white"
              >
                Non ora
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
